import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APIConfigMapping, HTTPAPIConfig, VlDataService, VlHttpService } from 'shared-library';
import { BehaviorSubject, Observable } from 'rxjs';
import { PAGEI, PAGE_CONFIG, THEME, WIDGET } from '../interfaces/page-interface';
import { APPLICATIONJSON, } from '../models/app-json';
import { PAGE } from '../models/page_config_json';
import { MatDialog } from '@angular/material/dialog';
import { PAGETYPES } from '../constants/proj.cnst';

@Injectable({
  providedIn: 'root'
})
export class WebServiceService {

  applicationMetaInfo: any;
  userMetaInfo: any;
  themeData: any;
  entireAppData: any;
  pageTypes = PAGETYPES;
  constructor(private route: ActivatedRoute,
    private dataService: VlDataService,
    private httpService: VlHttpService,
    private router: Router,
    public dialog: MatDialog) {
    this.router.events.subscribe((val: any) => {
      this.userMetaInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo') as string) : null;
    })
    const storedBreadcrumb = localStorage.getItem('breadcrumb');
    if (storedBreadcrumb) {
      this.breadcrumbSubject.next(JSON.parse(storedBreadcrumb));
    }
  }

  //#region this is used for setting and displaying sidenav-content

  private selectedOptionSubject = new BehaviorSubject<SidenavOption>({ label: 'default', isActive: false });

  selectedOption$: Observable<SidenavOption> = this.selectedOptionSubject.asObservable();

  private showMenuStatusSubject = new BehaviorSubject<boolean>(false);

  showMenuStatus$: Observable<boolean> = this.showMenuStatusSubject.asObservable();

  getShowMenuStatus() {
    return this.showMenuStatusSubject.value;
  }

  setShowMenuStatus(value: boolean) {
    this.showMenuStatusSubject.next(value);
  }

  private logoutUserSubject = new BehaviorSubject<boolean>(false);

  logoutUser$: Observable<boolean> = this.logoutUserSubject.asObservable();

  setlogoutUserStatus(value: boolean) {
    this.showMenuStatusSubject.next(value);
  }

  private stepperIndexSource = new BehaviorSubject<boolean>(false);
  currentStepperIndex = this.stepperIndexSource.asObservable();


  private onMobileScreenDropSubject = new BehaviorSubject<any>({});
  onMobileScreenDropSubjectdata$: Observable<any> = this.onMobileScreenDropSubject.asObservable();

  private sideNavListSubject = new BehaviorSubject<any>({});
  sideNavListSubjectData$: Observable<any> = this.sideNavListSubject.asObservable();

  private widgetLabelSubject = new BehaviorSubject<{ label: string, widgetId: string }>({ label: '', widgetId: '' }); // Initial value can be set if needed
  widgetLabel$ = this.widgetLabelSubject.asObservable();

  setWidgetLabel(label: string, widgetId: string) {
    this.widgetLabelSubject.next({ label, widgetId });
  }


  private widgetPlaceholderSubject = new BehaviorSubject<{ placeholder: string, widgetId: string }>({ placeholder: '', widgetId: '' }); // Initial value can be set if needed
  widgetPlaceholder$ = this.widgetPlaceholderSubject.asObservable();

  setWidgetPlaceholder(placeholder: string, widgetId: string) {
    this.widgetPlaceholderSubject.next({ placeholder, widgetId });
  }

  private widgetTextColorSubject = new BehaviorSubject<{ textColor: string, widgetId: string }>({ textColor: '', widgetId: '' }); // Initial value can be set if needed
  widgetTextColor$ = this.widgetTextColorSubject.asObservable();

  setWidgetTextColor(textColor: string, widgetId: string) {
    this.widgetTextColorSubject.next({ textColor, widgetId });
  }

  private breadcrumbSubject = new BehaviorSubject<{ id: any; label: any, state: any }[]>([]);
  breadcrumb$ = this.breadcrumbSubject.asObservable();

  updateBreadcrumb(breadcrumb: { id: any; label: any, state: any }[]) {
    this.breadcrumbSubject.next(breadcrumb);
    localStorage.setItem('breadcrumb', JSON.stringify(breadcrumb));
  }

  getBreadcrumb(): Observable<{ id: any; label: any, state: any }[]> {
    return this.breadcrumb$;
  }

  clearBreadcrumb() {
    this.breadcrumbSubject.next([]);
    localStorage.removeItem('breadcrumb');
    localStorage.removeItem('webAppInfo');
  }

  getCurrentBreadcrumb(): { id: any; label: any, state: any }[] {
    return this.breadcrumbSubject.getValue();
  }

  navigateByBreadcrumb(data: any, index: any) {
    if (index == 0) {
      this.clearBreadcrumb();
      this.router.navigate(['home']);
    }

    if (index == 1) {
      const currentBreadcrumb = this.getCurrentBreadcrumb();
      const newBreadcrumb = currentBreadcrumb.slice(0, index + 1);
      this.updateBreadcrumb(newBreadcrumb);
      this.router.navigate(['home', 'applications'], {
        queryParams: {
          "id": data.id,
          "projectName": data.label
        }
      });
    }

    if (index == 2 && data.state === 'mobile') {
      const currentBreadcrumb = this.getCurrentBreadcrumb();
      const newBreadcrumb = currentBreadcrumb.slice(0, index + 1);
      this.updateBreadcrumb(newBreadcrumb);
      this.router.navigate(['home', 'mobile'], {
        queryParams: {
          "id": data.id
        }
      });
    }

    if (index == 2 && data.state === 'web') {
      const currentBreadcrumb = this.getCurrentBreadcrumb();
      const newBreadcrumb = currentBreadcrumb.slice(0, index + 1);
      this.updateBreadcrumb(newBreadcrumb);
      this.router.navigate(['home', 'web']);
    }
  }

  onMobileScreenDropUpdateData(data: any) {
    this.onMobileScreenDropSubject.next(data);
  }

  onMobileScreenClearData() {
    let data = {};
    this.onMobileScreenDropSubject.next(data);
  }



  onSideNavListUpdateData(data: any) {
    this.sideNavListSubject.next(data);
  }

  setSelectedOption(label: string, isActive: boolean) {
    const option: SidenavOption = { label, isActive };
    this.selectedOptionSubject.next(option);
  }

  getSelectedOption() {
    return this.selectedOptionSubject.value;
  }
  //#endregion

  //#region this is used for setting and displaying sidenav-content-list
  private sidenavContentlistSubject = new BehaviorSubject<SideNavOptionForPages>({
    id: '',
    isActive: false
  });

  sidenavContentlistSubject$: Observable<SideNavOptionForPages> = this.sidenavContentlistSubject.asObservable();

  setSidenavContentlistOption(id: string, isActive: boolean) {
    const option: SideNavOptionForPages = { id, isActive };
    this.sidenavContentlistSubject.next(option);
  }

  getSidenavContentlist() {
    return this.sidenavContentlistSubject.value;
  }

  private WidgetListStatusSubject = new BehaviorSubject<boolean>(false);

  WidgetListStatus$: Observable<boolean> = this.WidgetListStatusSubject.asObservable();

  setWidgetListStatus(value: boolean) {

    this.WidgetListStatusSubject.next(value);
  }

  getSideNavStatus() {
    return this.WidgetListStatusSubject.value;
  }

  //#endregion

  //#region  this is for  pages 

  private pagesListSubject = new BehaviorSubject<PAGE[]>([]);
  pages$: Observable<PAGE[]> = this.pagesListSubject.asObservable();
  private defpagesListSubject = new BehaviorSubject<PAGE[]>([]);
  defpages$: Observable<PAGE[]> = this.defpagesListSubject.asObservable();
 
  formatPageBeforeUpdate(data: any[]) {
    let appData: APPLICATIONJSON = localStorage.getItem("application") ? JSON.parse(localStorage.getItem("application") as string) : {};
    const currentParams = { ...this.route.snapshot.queryParams };
    appData.pages = appData.pages.map((page: any) => {
      if (page.pageId === currentParams['pageId']) {
        const updatedPage = data.find((updatedPage: any) => updatedPage.pageId === currentParams['pageId']);
        if (updatedPage) {
          return { ...page, pageName: updatedPage.pageName, section: updatedPage.section };
        }
      }
      return page;
    });
    this.updateApplication(appData);
  }


  formatAppBeforeUpdate(data: any[]) {
    let appData: APPLICATIONJSON = localStorage.getItem("application") ? JSON.parse(localStorage.getItem("application") as string) : {};
    appData.pages = data;
    this.updateApplication(appData);
  }

  addPage1(applicationId: string, pageMeta: any): Observable<any> {
    let theme: THEME = this.themesSubject.value;
    let pageStyle = {
      backgroundColor: theme.defaultBackgroundColor
    }
    const page_config: PAGE_CONFIG = {
      style: pageStyle,
      actions: [],
      additionalConfig: {},
      pageForms: [],
      forms: []
    }
    const pagePostData: any = {
      applicationId: applicationId,
      pageName: pageMeta?.name,
      pageConfig: page_config,
    }
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_PAGE']);
    apiConfig.postData = pagePostData
    return new Observable((observer) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          pagePostData.pageId = data.pageId;
          const updatedPages = [...this.pagesListSubject.value, pagePostData];
          this.pagesListSubject.next(updatedPages);
          observer.next(data);
          observer.complete();
        },
        error: (data: any) => {
          observer.error(data);
          observer.complete();
        }
      })
    })
  }

  async deletePage(pageId: string): Promise<{ success: boolean, message?: string }> {
    return new Promise<{ success: boolean, message?: string }>((resolve, reject) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_PAGE']);
      apiConfig.postData = { page_id: pageId };

      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          const currentParams = { ...this.route.snapshot.queryParams };
          this.getAllPages(currentParams['id']);
          resolve({ success: true });
        },
        error: (data: any) => {
          resolve({ success: false, message: data.error[0].result });
        }
      });
    });
  }

  getAllDefaultPages(applicationTypeId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_MASTER_PAGES']);
    apiConfig.postData = {application_type_id: applicationTypeId};
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.defpagesListSubject.next(data);
      },
      error: (err: any) => {
        this.defpagesListSubject.next([])
      }
    })
    return this.defpages$;
  }

  async createAllDefaultPages(applicationId: string, defaultPageJson: any): Promise<any> {
    return await new Promise((resolve, reject) => {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_MASTER_PAGES']);
    apiConfig.postData = {
      applicationId: applicationId,
      defaultPages: defaultPageJson,
    };
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        resolve(data);
      },
      error: (err: any) => {
        reject(err);
      }
    })

    })
  }

  getAllPages(applicationId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGES']);
    apiConfig.postData = { application_id: applicationId }
    return  this.httpService.placeAPICall(apiConfig);
  }

  getPages(){
    return this.pagesListSubject.value;
  }

  setAllPages(pages:any){
    this.pagesListSubject.next(pages);
  }

  updatePageData(pagePostData: PAGE): Observable<any> {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_PAGE']);
    let userInfoString: any = localStorage.getItem('userInfo');
    let userId;
    if (userInfoString !== null) {
      const userInfo = JSON.parse(userInfoString);
       userId = userInfo.userId;
    }
    apiConfig.postData = pagePostData;
    apiConfig.postData['userId'] = userId;
    return new Observable((observer) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          pagePostData.pageId = data?.pageId;
          let previousPagesData = this.pagesListSubject.value;
          previousPagesData = previousPagesData.map((page: PAGE) => (page.pageId == pagePostData.pageId ? pagePostData : page));
          this.pagesListSubject.next(previousPagesData);
          observer.next(data); 
          observer.complete(); 
        },
        error: (error: any) => {
          observer.error(error); 
          observer.complete(); 
        }
      });
    });
  }

  addPageData(applicationId: string,pageName:any):Observable<any> {
   
    let theme : THEME = this.themesSubject.value;
    let pageStyle = {
      backgroundColor: theme.defaultBackgroundColor
    }
    const page_config: any = {
      style : pageStyle,
      actions: [],
      additionalConfig: {},
      pageForms : [],
      forms : []
    } 
    const pagePostData: any = {
      applicationId: applicationId,
      pageName: pageName,
      pageConfig: page_config,
      pageType:this.pageTypes.customPage
    }
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_PAGE']);
    apiConfig.postData = pagePostData
    return new Observable((observer) => {
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        pagePostData.pageId = data.pageId;
        const updatedPages = [...this.pagesListSubject.value, pagePostData];
        this.pagesListSubject.next(updatedPages);
        observer.next(data); 
        observer.complete();
      },
      error: (data: any) => {
        observer.error(data); 
        observer.complete(); 
      }
    })})
  }

  private getAllPagesRefreshAction = new BehaviorSubject<boolean>(false);
  getAllPagesRefreshAction$: Observable<boolean> = this.getAllPagesRefreshAction.asObservable();

  getAllPagesRefreshActionTrigger() {
    this.getAllPagesRefreshAction.next(true);
  }

  async getAlldefaultPages(applicationId: string): Promise<any> {
    return await new Promise((resolve, reject) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGES']);
      apiConfig.postData = { application_id: applicationId };
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          resolve(data); // Resolve the Promise with the fetched data
        },
        error: (err: any) => {
          reject(err); // Reject the Promise with the error
        },
      });
    });
  }

  getPageById(pageId: string): any {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGE']);
    apiConfig.postData = { page_id: pageId }
    return this.httpService.placeAPICall(apiConfig);
  }


  updateApplication(jsonData: APPLICATIONJSON) {
    localStorage.setItem("application", JSON.stringify(jsonData));
  }

  updateWidgetData(pageId: string, sectionIndex: number, widgetIndex: number, widget: WIDGET): void {
    let page: PAGEI = this.getSelectedPage();
    this.setSelectedPage(page);
  }

  //#endregion

  async fetchEntity(id: string, type: any) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_ENTITIES_OR_ATTRIBUTES']);
    apiConfig.postData = type == 'application' ? {
      application_id: id,
      entity_id: null,
      project_id: null,
      parent_entity_id: null
    } : { page_id: id }
    const returnData: any = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          resolve(response.data);
        },
        complete: () => { },
        error: (error: any) => {
          reject(error);
        }
      });
    });
    return returnData;
  }
  saveEntiy(type: any, postData: any, applicationId?: any, entityForm?: any, newPageId?: any,) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['UPDATE_ENTITY']);
    apiConfig.postData = type != 'edit' ? {
      entity_id: entityForm?.entity_id ? entityForm?.entity_id : null,
      entity_name: entityForm?.entity_name ? entityForm?.entity_name : entityForm,
      child_entity_ids_relation: entityForm?.child_entity_ids_relation ? entityForm?.child_entity_ids_relation : null,
      application_id: applicationId,
      page_ids_list: entityForm?.page_ids_list ? entityForm?.page_ids_list : [newPageId],
      removal_page_ids_list: entityForm?.removal_page_ids_list ? entityForm?.removal_page_ids_list : [],
      removal_child_entity_ids_relation: entityForm?.removal_child_entity_ids_relation ? entityForm?.removal_child_entity_ids_relation : []
    } : postData
    return new Observable((observer) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          observer.next(data);
          observer.complete();
        },
        error: (data: any) => {
          observer.error(data);
          observer.complete();
        }
      })
    })
  }


  //#region  application info
  private applicationDataSubject = new BehaviorSubject<any>({});

  applicationDataObj$: Observable<any> = this.applicationDataSubject.asObservable();

  setApplicationData(applicationData: any) {
    this.applicationDataSubject.next(applicationData);
  }

  getApplicationData() {
    return this.applicationDataSubject.value;
  }

  //#endregion


  //#region indicator to show if section is editable

  private displayRestrictedAreaSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  displayRestrictedArea$ = this.displayRestrictedAreaSubject.asObservable();

  setDisplayRestrictedArea(value: boolean) {
    this.displayRestrictedAreaSubject.next(value);
  }

  //#endregion

  //#region  for themes

  private themesSubject = new BehaviorSubject<THEME>({
    themeName: 'M3 Baseline Light',
    primaryColor: "#0061A6",
    secondaryColor: "#6C5778",
    defaultBackgroundColor: "#FAF9FD",
    defaultTextColor: "#45474A",
  })

  themesObj: Observable<THEME> = this.themesSubject.asObservable();

  setWholeTheme(data:any){
    let theme = this.themesSubject.value; 
    theme.themeName = data.theme_name;
    theme.primaryColor = data.primary_color;
    theme.secondaryColor = data.secondary_color;
    theme.defaultBackgroundColor = data.background_color;
    theme.defaultTextColor = data.text_color;
    theme.headingFontStyle = data.font_heading;
    theme.bodyFontStyle = data.font_body;
    this.themesSubject.next(theme);
  }

  getWholeTheme(){
    return this.themesSubject.value;
  }


  setThemesData(themeItemName: string, themeItemValue: string) {
    let theme: THEME = this.themesSubject.value;

    switch (themeItemName) {
      case 'themeName':
        theme.themeName = themeItemValue;
        break;
      case 'primaryColor':
        theme.primaryColor = themeItemValue;
        break;
      case 'secondaryColor':
        theme.secondaryColor = themeItemValue;
        break;
      case 'defaultBackgroundColor':
        theme.defaultBackgroundColor = themeItemValue;
        break;
      case 'defaultTextColor':
        theme.defaultTextColor = themeItemValue;
        break;
      case 'headingFontStyle':
        theme.headingFontStyle = themeItemValue;
        break;
      case 'bodyFontStyle':
        theme.bodyFontStyle = themeItemValue;
        break;
      default:
        return;
    }
    this.themesSubject.next(theme);
  }


  setApplicationDataById(data: any) {
    this.applicationMetaInfo = data;
  }

  getApplicationDataById() {
    return this.applicationMetaInfo;
  }
  //#region pages expanstion panel opener

  private expansionPanelStatesSubject = new BehaviorSubject<EXAPANSIONPANELDETAILS>({ pageID: '', sectionIndex: 0 })

  expansionPanelStatesObj: Observable<EXAPANSIONPANELDETAILS> = this.expansionPanelStatesSubject.asObservable();

  getPagesExpansionPanelOpener() {
    return this.expansionPanelStatesSubject.value;
  }

  setPagesExpansionPanelOpener(data: EXAPANSIONPANELDETAILS) {
    this.expansionPanelStatesSubject.next(data)
  }
  //#endregion

  createForm(formPostData: any): any {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_FORM']);
    apiConfig.postData = formPostData;
    apiConfig.postData['createdBy'] = this.userMetaInfo?.userId
    return this.httpService.placeAPICall(apiConfig)
  }

  updateForm(formPostData: any, formId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_FORM']);
    apiConfig.postData = formPostData;
    apiConfig.postData['userId'] = this.userMetaInfo?.userId;
    apiConfig.postData['formId'] = formId;
    return this.httpService.placeAPICall(apiConfig);
  }

  createWidget(widgetPostData: any): Observable<any> {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_EDIT_WIDGET']);
    apiConfig.postData = widgetPostData;
    return this.httpService.placeAPICall(apiConfig);
  }

  createDropedPage(payload: any) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_PAGE']);
    apiConfig.postData = payload;
    return this.httpService.placeAPICall(apiConfig);
  }
  updateWidget(widgetPostData: any, widgetId: any) {
    const currentParams = { ...this.route.snapshot.queryParams };
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_EDIT_WIDGET']);
    apiConfig.postData = widgetPostData;
    apiConfig.postData['widgetId'] = widgetId;
    apiConfig.postData['userId'] = this.userMetaInfo?.userId;
    apiConfig.postData['applicationId'] = currentParams['id'];
    return this.httpService.placeAPICall(apiConfig);
  }


  updateWidgetImage(image:any, widgetId: any,key?:string): any{
    const currentParams = { ...this.route.snapshot.queryParams };
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['ADD_OR_UPDATE_WIDGET_IMAGE']);
    apiConfig.postData = {};
    apiConfig.postData['widgetId'] = widgetId;
    apiConfig.postData['image'] = image;
    if(key){
    apiConfig.postData['key'] = key;
    }
    apiConfig.postData['applicationId'] = currentParams['id'];
    return this.httpService.placeAPICall(apiConfig);
  }
  
  deleteWidget(currentPageData: any, formIndex: any, widgetId: any) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_WIDGET']);
    apiConfig.postData = { widget_id: widgetId };

    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
      },
      error: (data: any) => {

      }
    })
  }


  deleteForm(formId: string, currentPage: any): Observable<any> {
    return new Observable((observer) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_FORM']);
      apiConfig.postData = { form_id: formId };
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          observer.next(true);
          observer.complete();
        },
        error: (data: any) => {

        }
      })
    })
  }


  private selectedPageSubject = new BehaviorSubject<any>({ pageId: '', pageName: '', applicationId: '', pageType: '' });

  selectedPageObj$: Observable<any> = this.selectedPageSubject.asObservable();

  setSelectedPage(data: any) {
    this.selectedPageSubject.next(data);
  }

  getSelectedPage() {
    return this.selectedPageSubject.value;
  }

  //#region  dropdown datasource

  private dataSourceApiValues = new BehaviorSubject<{widgetId:string,responce:any,field:any}>({widgetId:"",responce:[],field:""});

  dataSourceApiValues$: Observable<{widgetId:string,responce:any,field:any}> = this.dataSourceApiValues.asObservable();

  setDataSourceApiValues(apiValues :{widgetId:string,responce:any,field:any}){
    this.dataSourceApiValues.next(apiValues);
  }

  getDataSourceApivales() {
    return this.dataSourceApiValues.value;
  }
  setThemeData(themeData: any) {
    this.themeData = themeData;
  }
  getThemeData() {
    return this.themeData;
  }

  setApplicationDataEntire(appData: any) {
    this.entireAppData = appData;
  }
  getApplicationDataEntire() {
    return this.entireAppData;
  }

  setStepperIndexValue(apiCalled: boolean) {
    this.stepperIndexSource.next(apiCalled);
  }
  //#endregion
}


interface SidenavOption {
  label: string;
  isActive: boolean;
}


interface SideNavOptionForPages {
  id: string,
  isActive: boolean
}

interface EXAPANSIONPANELDETAILS {
  pageID: string;
  sectionIndex: number;
  widgetIndex?: string;

}